










import { Vue, Component } from 'vue-property-decorator'
import { exchangeHandoffCode, isPortalEnabled, redirectToPortalLogin, takeVerifiedIntended } from '@/auth-portal'

const MESSAGES: Record<string, string> = {
  forbidden: 'Your account does not have access to Engage.',
  invalid_or_expired_code: 'Your sign-in link has expired. Please sign in again.',
  unverified: 'This sign-in was not started from this browser. Please sign in again.',
}

@Component({})
export default class Sso extends Vue {
  $login: any
  $http: any
  error: string | null = null

  intended = '/dashboard'

  async mounted () {
    const handoff = (window as any).__engageSso || {}
    delete (window as any).__engageSso
    const code = handoff.code
    const verifiedIntended = takeVerifiedIntended(handoff.intended)
    window.history.replaceState(null, '', '/sso')

    if (!isPortalEnabled()) {
      this.$router.replace({ name: 'login' })
      return
    }
    if (typeof code !== 'string' || !code) {
      this.error = MESSAGES.invalid_or_expired_code
      return
    }
    if (!verifiedIntended) {
      this.error = MESSAGES.unverified
      return
    }
    this.intended = verifiedIntended === '/' ? '/dashboard' : verifiedIntended

    try {
      const token = await exchangeHandoffCode(code)
      this.$login.setToken(token, false)
      const response = await this.$http.get('/user')
      this.$login.setUser(response.data)
      if (!this.$login.is()) {
        this.error = MESSAGES.forbidden
        return
      }
      this.$login.setToken(token, true)
      this.$router.replace(this.intended)
    } catch (e) {
      this.$login.logout()
      this.error = MESSAGES[(e as Error).message] || 'We could not sign you in. Please try again.'
    }
  }

  retry () {
    redirectToPortalLogin(this.intended, true)
  }
}
